import React from 'react'
import {Switch} from 'antd'

const BSwitch = ({className = '', ...props}) => (
  <Switch className={`bSwitch ${className}`} {...props}/>
)

export default BSwitch
